import { ISnAudio } from './audio';
import { ISnVideo } from './video';

export interface ISnStream {
  audio: ISnAudio;
  video: ISnVideo;
}
